import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { JOTFORM_URL, WHATSAPP_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";
import { resolveAssetUrl } from "../lib/api";

const FinalCTA = () => {
  const { content } = useSite();
  const c = content.finalCta || {};
  return (
    <section style={{ padding: "0 24px 60px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", background: "#FF4F1A", borderRadius: 32, padding: "56px 56px", display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 40, alignItems: "center", overflow: "hidden", position: "relative" }} className="finalcta-grid fade-in">
        <div style={{ color: "#fff" }}>
          <span className="pill" style={{ background: "rgba(255,255,255,0.18)", color: "#fff", marginBottom: 16 }}>{c.kicker}</span>
          <h2 className="h-display" style={{ fontSize: "clamp(30px, 4.2vw, 54px)", color: "#fff", margin: "12px 0 18px" }}>
            {c.titleLine1}<br />{c.titleLine2}<br />{c.titleLine3}
          </h2>
          <p style={{ color: "rgba(255,255,255,0.92)", fontSize: 16, lineHeight: 1.55, marginBottom: 26, maxWidth: 520 }}>{c.subtitle}</p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="btn-dark">
              {c.primaryCtaText} <ArrowRight size={16} />
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-white">
              <MessageCircle size={16} /> {c.secondaryCtaText}
            </a>
          </div>
        </div>
        <div className="img-zoom-wrap" style={{ borderRadius: 22, aspectRatio: "4/3" }}>
          <img src={resolveAssetUrl(c.image)} alt="" className="img-zoom" />
        </div>
      </div>
      <style>{`@media (max-width: 900px){.finalcta-grid{grid-template-columns:1fr !important;padding:36px !important;}}`}</style>
    </section>
  );
};

export default FinalCTA;
